import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage, t } from '../../context/LanguageContext';
import podService from '../../services/podService';

function PodBadge({ podStatus, lang }) {
  if (!podStatus || podStatus === 'none') return null;
  if (podStatus === 'signed') {
    return (
      <span className="badge bg-success" style={{ fontSize: 11 }}>
        ✅ {t('Signed', 'Firmado', lang)}
      </span>
    );
  }
  return (
    <span className="badge bg-secondary" style={{ fontSize: 11 }}>
      📎 {t('Photo captured', 'Foto capturada', lang)}
    </span>
  );
}

export default function PortalDeliveriesPage() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    podService.getPortalDeliveries()
      .then(data => setOrders(data))
      .catch(() => setError(t('Failed to load deliveries.', 'Error al cargar las entregas.', lang)))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <div className="text-center py-5"><span className="spinner-border spinner-border-sm" /></div>;
  if (error) return <div className="alert alert-warning" style={{ fontSize: 13 }}>{error}</div>;

  if (orders.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        <div style={{ fontSize: 40, marginBottom: 8 }}>🚚</div>
        <p style={{ fontSize: 14 }}>{t('No deliveries ready today.', 'No hay entregas listas hoy.', lang)}</p>
      </div>
    );
  }

  return (
    <div>
      <h6 className="fw-bold mb-3">{t('Deliveries', 'Entregas', lang)}</h6>
      <div className="d-flex flex-column gap-3">
        {orders.map(order => {
          const itemsSummary = (order.Items || [])
            .map(i => `${i.quantity}× ${i.Product?.name || '?'}`)
            .join(', ');
          const hasPod = order.podStatus && order.podStatus !== 'none';

          return (
            <div
              key={order.id}
              className="card shadow-sm"
              style={{ border: hasPod ? '1px solid #198754' : '1px solid #dee2e6' }}
            >
              <div className="card-body" style={{ padding: '12px 14px' }}>
                <div className="d-flex justify-content-between align-items-start mb-1">
                  <div className="fw-bold" style={{ fontSize: 14 }}>
                    #{order.orderNumber}
                  </div>
                  <PodBadge podStatus={order.podStatus} lang={lang} />
                </div>
                <div style={{ fontSize: 13, color: '#495057' }}>
                  {order.Customer?.name || t('No customer', 'Sin cliente', lang)}
                </div>
                {itemsSummary && (
                  <div style={{ fontSize: 12, color: '#6c757d', marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {itemsSummary}
                  </div>
                )}
                <button
                  className={`btn btn-sm mt-2 w-100 ${hasPod ? 'btn-outline-success' : 'btn-primary'}`}
                  style={{ fontSize: 13 }}
                  onClick={() => navigate(`/portal/deliveries/${order.id}/pod`)}
                >
                  {hasPod
                    ? t('View / Add POD', 'Ver / Agregar prueba', lang)
                    : t('Capture Delivery Proof', 'Capturar prueba de entrega', lang)}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
